/**
 * Retry logic for dynamic imports to handle transient network failures on mobile devices.
 * Inlined here because virtual modules cannot import from regular files.
 */
async function importWithRetry(importFn, retries = 3) {
  for (let i = 0; i < retries; i++) {
    try {
      return await importFn();
    } catch (error) {
      if (i === retries - 1) throw error;
      // Exponential backoff: 1s, 2s, 3s
      await new Promise(r => setTimeout(r, 1000 * (i + 1)));
    }
  }
}

export const scripts = {
  "es": {
    languageLabel: "Spanish",
    load: async () => (await importWithRetry(() => import("virtual:script/es"))).default,
  },
  "nl": {
    languageLabel: "Dutch",
    load: async () => (await importWithRetry(() => import("virtual:script/nl"))).default,
  },
  "fr": {
    languageLabel: "French",
    load: async () => (await importWithRetry(() => import("virtual:script/fr"))).default,
  },
  "en": {
    languageLabel: "English",
    load: async () => (await importWithRetry(() => import("virtual:script/en"))).default,
  }
};